import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import ChangeHistory from '../../../../../features/components/ChangeHistoryDrawer/ChangeHistory'
import Drawer from '../../../../../components/Drawer'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'

import { lineItemsSelector } from '../../../../../modules/selectors/lineItems'

import { CHANGE_LINE_ITEM_HISTORY } from '../../../../../constants/forms'
import { TYPE_LINE_ITEM } from '../../../../../constants/changeHistory'

function LineItemsChangeHistory({ platform }) {
  const lineItems = useSelector(lineItemsSelector)
  const { isFormOpen, handleFormClose, selectedEditItemId } = useManageDrawer({ formName: CHANGE_LINE_ITEM_HISTORY })

  const selectedLineItemData = useMemo(
    () => selectedEditItemId && lineItems.find(({ id }) => id === selectedEditItemId),
    [selectedEditItemId, lineItems]
  )
  const historyDrawerTitle = `Change History for '${selectedLineItemData?.name}'`

  return (
    <Drawer isOpen={isFormOpen} onClose={handleFormClose} title={historyDrawerTitle || 'Change History'}>
      <ChangeHistory historyType={TYPE_LINE_ITEM} platform={platform} itemId={selectedEditItemId} />
    </Drawer>
  )
}

LineItemsChangeHistory.propTypes = {
  platform: PropTypes.string.isRequired
}

export default LineItemsChangeHistory
